/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 1:38 PM
 *
 */

import ErrorState from 'components/ErrorState/ErrorState';

export default ErrorState;
